import styled from 'styled-components'
import { spaces } from 'styles/mixins'

export const FormWrapper = styled.div`
  min-width: 400px;
  margin-bottom: ${spaces.large2};
`